"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_final_form_1 = require("react-final-form");
var Checkbox_1 = __importDefault(require("atomicComponents/atoms/Forms/Checkbox"));
var constants_1 = require("containers/TableMaker/constants");
var CheckboxWrapper_1 = __importDefault(require("./CheckboxWrapper"));
var EmailHeadersCell_1 = __importDefault(require("./EmailHeadersCell"));
var EmailHeadersRow_1 = __importDefault(require("./EmailHeadersRow"));
var Header_1 = __importDefault(require("./Header"));
var TableFieldText_1 = __importStar(require("./TableFieldText"));
var XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD, XSM = constants_1.CellSize.XSM;
var MainContact = function () { return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ pb: 5 }, { children: [(0, jsx_runtime_1.jsx)(Header_1.default, { heading: "Main contact address", description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["This is the email that your customers use to get in touch with you, and it'll be used as the default", ' ', (0, jsx_runtime_1.jsx)("strong", { children: "reply-to" }), "."] })) }), (0, jsx_runtime_1.jsxs)(EmailHeadersRow_1.default, { children: [(0, jsx_runtime_1.jsx)(EmailHeadersCell_1.default, __assign({ width: XL + XSM + 4 }, { children: (0, jsx_runtime_1.jsx)(TableFieldText_1.TableFieldEmail, { name: "contact.email" }) })), (0, jsx_runtime_1.jsx)(EmailHeadersCell_1.default, __assign({ width: LG + 8 }, { children: (0, jsx_runtime_1.jsx)(TableFieldText_1.default, { name: "contact.name", placeholder: "Name" }) })), (0, jsx_runtime_1.jsx)(EmailHeadersCell_1.default, __assign({ width: MD + 8 }, { children: (0, jsx_runtime_1.jsx)(CheckboxWrapper_1.default, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: Checkbox_1.default, name: "addContactInCc", color: "neutral", label: "Add in CC", type: "checkbox", gap: 0.875, toggleLabel: true }) }) }))] })] }))); };
exports.default = MainContact;
